import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import U from './lib/vendor/eve/lib-utils'
import { central_data } from './lib/vendor/eve/planhub/lib-central-data'
// сначала CD
central_data().ready(function () {
  //login interceptor
  axios.interceptors.response.use(function (response) {
    if (U.isObject(response.data)) {
      if (response.data.status === 'auth') {
        if (!/^\/login/.test(router.currentRoute.value.path)) {
          router.replace({
            path: '/login',
            query: { ret: router.currentRoute.value.fullPath },
          })
          return null
        } else {
          response.data.status = 'error'
        }
      }
    }
    //  console.log('login-incept:',response);
    return response
  })
  //app creation
  var app = createApp(App)
  app.use(router)
  app.mount('#app')
})
